// @flow

import axios from 'axios';
import { getBaseUrl } from '../config/config';

export default function getTaskDetail(projectId: string, activityId: string, taskId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/activities/${activityId}/tasks/${taskId}`);
}
